import React from "react";
import update from 'immutability-helper';

import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import Card from 'react-bootstrap/Card';
import { Badge } from 'primereact/badge';
import { Message } from 'primereact/message';


import { RiskLevels, ConsequenceLevels, ProbabilityLevels, ControlTypes, MitigationStatus } from './RiskLevels'

import UserContext from '../context/UserContext';


class MitigationDialog extends React.Component {

	static contextType = UserContext;

	state = {
		mitigation: {
			mitigationID: 0,
			riskID: 0,
			name: 'New mitigation project',
			mitigationType: 1,
			description: '',
			deadline: new Date().toISOString().split('T')[0],
			status: 1,
			comment: '',
			responsible: '',
			consequenceAfter: 1,
			probabilityAfter: 1,
		},
		modified: false,
		isLoadingData: false,
		deadline: new Date(),

		risk: {
			riskID: 0,
			name: '',
			process: '',
			category: 1,
			owner: 0,
			description: '',
			rootCause: '',
			potentialConsequence: '',
			consequence: 1,
			probability: 1,
		},
	};


	componentDidMount() {
		this.setState({ risk: this.props.risk });
		this.onChange('riskID', this.props.risk.riskID);
		if (this.props.mitigationID !== 0) {
			this.fetchMitigation(this.props.mitigationID);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.risk !== this.props.risk && this.props.risk !== null) {
			this.setState({ risk: this.props.risk });
			this.onChange('riskID', this.props.risk.riskID);
		}
		if (prevProps.mitigationID !== this.props.mitigationID) {
			if (this.props.mitigationID !== 0) {
				this.fetchMitigation(this.props.mitigationID);
			} else {
				this.resetForm();
			}
		}
		if (prevProps.visible !== this.props.visible && !this.props.visible) {
			this.resetForm()
		}
	}

	resetForm() {
		const riskID = this.state.risk.riskID;
		this.setState({
			mitigation: {
				mitigationID: 0,
				riskID: riskID,
				name: 'New mitigation project',
				mitigationType: 1,
				description: '',
				deadline: new Date().toISOString().split('T')[0],
				status: 1,
				comment: '',
				responsible: '',
				consequenceAfter: 1,
				probabilityAfter: 1,
			},
			modified: false,
			deadline: new Date(),
		});
	}

	fetchMitigation(mitigationID) {
		this.setState({ isLoadingData: true });
		fetch(`api/Mitigation/GetMitigation/` + mitigationID, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				const deadline = new Date(data.deadline);
				data.deadline = new Date(deadline).toISOString().split('T')[0];

				this.setState({ mitigation: data });
				this.setState({ deadline: deadline });
				this.setState({ hasChanged: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	fetchAddMitigation() {
		this.setState({ isLoadingData: true });

		fetch('api/Mitigation/AddMitigation', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify( this.state.mitigation ) })
		.then((response) => {
			return response.json();
		})
		.then((data) => {
			if (data.error) {
				throw (data.error);
			}
			if (this.props.onClose != null) {
				this.props.onClose(true);
			}
			this.setState({ isLoadingData: false });
		})
		.catch(error => {
			this.setState({ isLoadingData: false });
		})
	}

	fetchChangeMitigation() {
		this.setState({ isLoadingData: true });
		fetch(`api/Mitigation/ChangeMitigation`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.mitigation) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				if (this.props.onClose != null) {
					this.props.onClose(true);
				}
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	cancelDialog() {
		if (this.props.onClose != null) {
			this.setState({ hasChanged: false });
			this.props.onClose(false);
		}
	}

	closeDialog() {
		if (this.state.mitigation.mitigationID === 0) {
			this.fetchAddMitigation();
			this.setState({ hasChanged: false });
		} else {
			this.fetchChangeMitigation();
			this.setState({ hasChanged: false });
		}
	}

	onChange(field, value) {
		const mitigation = update(this.state.mitigation, { [field]: { $set: value } });
		this.setState({ mitigation: mitigation });
		this.setState({ modified: true });
	}

	onDeadlineChange(value) {
		const year = value.getFullYear();
		const month = String(value.getMonth() + 1).padStart(2, '0'); 
		const day = String(value.getDate()).padStart(2, '0');

		const deadline = `${year}-${month}-${day}`;
				
		const mitigation = update(this.state.mitigation, { deadline: { $set: deadline } });
		this.setState({ mitigation: mitigation });
		this.setState({ modified: true });
		this.setState({ deadline: value });
	}

	probabilityOptionTemplate(option) {
		if (option.id > this.state.risk.probability) {
			return (
				<div className="flex align-items-center">
					<div style={{ color: "lightgrey" }}>{option.text}</div>
				</div>
			);
		}
		return (
			<div className="flex align-items-center">
				<div>{option.text}</div>
			</div>
		);
	}

	consequenceOptionTemplate(option) {
		if (option.id > this.state.risk.consequence) {
			return (
				<div className="flex align-items-center">
					<div style={{ color: "lightgrey" }}>{option.text}</div>
				</div>
			);
		}
		return (
			<div className="flex align-items-center">
				<div>{option.text}</div>
			</div>
		);
	}

	statusSelectedTemplate = (option) => {
		if (option) {
			return (
				<div className="flex align-items-center">
					<Badge value=" " style={{backgroundColor:option.color} }></Badge>&nbsp;
					<div>{option.name}</div>
				</div>
			);
		}
	};

	render() {
		const riskBgColor = RiskLevels[this.state.mitigation.consequenceAfter - 1][this.state.mitigation.probabilityAfter - 1].bgColor;
		const riskColor = RiskLevels[this.state.mitigation.consequenceAfter - 1][this.state.mitigation.probabilityAfter - 1].color;

		const now = new Date();
		var deadline = new Date(this.state.mitigation.deadline);
		deadline.setHours(0);
		deadline.setMinutes(0);
		deadline.setSeconds(0, 0);
		const overdue = deadline.getTime() + 86400000 < now.getTime();
		
		const footerContent = (
			<div>
				<Button label="Cancel" icon="pi pi-times" onClick={() => this.cancelDialog()} className="p-button-secondary" />
				<Button label="Save and close" icon="pi pi-check" onClick={() => this.closeDialog()} disabled={!this.state.modified} />
			</div>
		);

		return (
			<Dialog header="Mitigation" visible={this.props.visible} style={{ width: '75vw', height: '75vh', overflow: 'hidden' }} maximizable footer={footerContent}
				modal contentStyle={{ height: '300px' }} closable={false} >
				<ConfirmDialog />

				<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto' }}>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }}>
						<Card.Header>
							<b>Details</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem">
								<div className="p-field">
									<label className="p-field-label">Name</label>
									<InputText value={this.state.mitigation.name} maxLength="50" onChange={(e) => { this.onChange('name', e.target.value) }} className="w-full md:w-20rem" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Mitigation type</label>
									<Dropdown value={this.state.mitigation.mitigationType} onChange={(e) => { this.onChange('mitigationType', e.target.value); }} options={ControlTypes} optionValue="id" optionLabel="name" placeholder=" " className="w-full md:w-20rem" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Description</label>
									<InputTextarea className="w-full md:w-20rem" value={this.state.mitigation.description} onChange={(e) => this.onChange('description', e.target.value) } rows={3} cols={30} placeholder="" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Responsible</label>
									<InputText className="w-full md:w-20rem" value={this.state.mitigation.responsible} onChange={(e) => this.onChange('responsible', e.target.value)} />
								</div>

							</div>
						</Card.Body>
					</Card>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }} >
						<Card.Header>
							<b>Risk after mitigation</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem" style={{ minWidth: '20rem' }}>
								{this.state.mitigation.consequenceAfter > this.state.risk.consequence ?
									<Message severity="warn" text="Higher consequence after mitigation" />
									: this.state.mitigation.probabilityAfter > this.state.risk.probability ?
										<Message severity="warn" text="Higher probability after mitigation" />
										: this.state.mitigation.consequenceAfter === this.state.risk.consequence && this.state.mitigation.probabilityAfter === this.state.risk.probability ?
											<Message severity="warn" text="No change in risk after mitigation" />
											: null
								}

								<div className="p-field">
									<label className="p-field-label">Probability</label>

									<Dropdown
										value={this.state.mitigation.probabilityAfter}
										onChange={(e) => { this.onChange('probabilityAfter', e.target.value) }}
										options={ProbabilityLevels}
										optionLabel="text"
										optionValue="id"
										placeholder=" "
										className="w-full md:w-20rem"
										itemTemplate={this.probabilityOptionTemplate.bind(this)}
									/>
								</div>

								<div className="p-field">
									<label className="p-field-label">Consequence</label>

									<Dropdown
										value={this.state.mitigation.consequenceAfter}
										onChange={(e) => { this.onChange('consequenceAfter', e.target.value)  }}
										options={ConsequenceLevels}
										optionLabel="text"
										optionValue="id"
										placeholder=" "
										className="w-full md:w-20rem"
										itemTemplate={this.consequenceOptionTemplate.bind(this)}
									/>
								</div>

								<div className="p-field">
									<label className="p-field-label">Risk</label>
									<InputText value={RiskLevels[this.state.mitigation.consequenceAfter - 1][this.state.mitigation.probabilityAfter - 1].label} style={{ backgroundColor: riskBgColor, color: riskColor }} className="w-full md:w-20rem" />
								</div>
							</div>
						</Card.Body>
					</Card>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }}>
						<Card.Header>
							<b>Progress</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem">
								
								<div className="p-field">
									<label className="p-field-label">Deadline</label>
									<Calendar value={this.state.deadline} onChange={(e) => this.onDeadlineChange(e.value) } dateFormat="yy-mm-dd" showIcon className={overdue ? "p-invalid" : null} />
								</div>

								<div className="p-field">
									<label className="p-field-label">Status</label>
									<Dropdown
										value={this.state.mitigation.status}
										onChange={(e) => { this.onChange('status', e.target.value); }}
										options={MitigationStatus}
										optionValue="id"
										optionLabel="name"
										placeholder=" "
										className="w-full md:w-20rem"
										valueTemplate={this.statusSelectedTemplate.bind(this)}
										itemTemplate={this.statusSelectedTemplate.bind(this)}
									/>
								</div>
							
								<div className="p-field">
									<label className="p-field-label">Comment</label>
									<InputTextarea className="w-full md:w-20rem" value={this.state.mitigation.comment} onChange={(e) => this.onChange('comment', e.target.value)} rows={3} cols={30} placeholder="" />
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
			</Dialog>
		);
	}
}
export default (MitigationDialog);